import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/agendamentos')({
  component: AgendamentosLayout,
})

function AgendamentosLayout() {
  return <Outlet />
}
